module.exports = __webpack_public_path__ + "static/media/chapter-prev-button.84760fbb.svg";